import React from "react";
import "./Navbar.css";
import { Link } from "react-scroll";
import { BsDiscord, BsTwitter } from "react-icons/bs";
import Logo from "../../assets/logo.png";

const Navbar = () => {
  return (
    <div className="navbar-container lo-res" id="navbar">
      <img src={Logo} alt="BearX" />
      <div className="navbar-links">
        <Link
          className="navbar-link"
          activeClass="active"
          to="about"
          spy={true}
          smooth={true}
        >
          About
        </Link>
        <Link
          className="navbar-link"
          activeClass="active"
          to="faq"
          spy={true}
          smooth={true}
        >
          FAQ
        </Link>
        <Link
          className="navbar-link"
          activeClass="active"
          to="team"
          spy={true}
          smooth={true}
        >
          Team
        </Link>
      </div>
      <div className="navbar-buttons">
        <a
          href="https://t.co/VtmjGXDeLw?amp=1"
          target="_blank"
          rel="noreferrer"
        >
          <BsDiscord className="navbar-button" />
        </a>
        <a
          href="https://twitter.com/bearX_NFT"
          target="_blank"
          rel="noreferrer"
        >
          <BsTwitter className="navbar-button" />
        </a>
        <div className="navbar-button connect">CONNECT</div>
      </div>
    </div>
  );
};

export default Navbar;
